import ATMLoadProfileCreateComponent from './atm_load_profile.create.component';

let ATMLoadProfileCreateModule = angular.module('atmLoadProfileCreate', [
  ])

  .component('atmLoadProfileCreate', ATMLoadProfileCreateComponent)

  .name;

export default ATMLoadProfileCreateModule;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/atm_load_profile/create/index.js